import {
  TypeItemModel,
  TypeModel
} from "./chunk-CFTJBEYG.js";
import {
  Route_default
} from "./chunk-JZ7NRADT.js";

// src/Pim/PimType/index.ts
import axios from "axios";
var TypeApiService = class {
  constructor() {
    this.route = null;
    this.create = async (data) => {
      try {
        const result = await this.route.create(data);
        if (result) {
          return result;
        }
        return { message: "Something have problem" };
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.update = async (data) => {
      try {
        const result = await this.route.update(data);
        if (result) {
          return result;
        }
        return { message: "Something have problem" };
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.delete = async (data) => {
      try {
        const response = await this.route.delete(data);
        if (response) {
          return response;
        } else {
          return false;
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.getList = async (filter) => {
      try {
        const data = await this.route.getList(filter);
        const roleItems = new TypeModel(data);
        return {
          listItems: roleItems.getItems(),
          pagination: roleItems.getPagination()
        };
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.getDetail = async (id = 0) => {
      try {
        const data = await this.route.getDetail(id);
        let results = null;
        if (data) {
          results = new TypeItemModel(data);
        }
        if (results) {
          results = results.toJSON();
        }
        return results;
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.route = new Route_default();
  }
};

export {
  TypeApiService
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
